import Search16 from '@carbon/icons-react/es/search/16';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { PropsWithChildren, ReactNode, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Team, User } from 'api/models';
import { Input } from 'components/atoms/input';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import {
  RoundedCheckbox,
  SearchInput,
} from 'components/organisms/timesheets/drawers/components';
import { PartnershipIcon } from '../../components';
import { AddToProjectRecordType, ReplacementUserForTeam } from '../../types';
import { EntityListTable } from '../table';

export const NameCellWithoutPadding = styled(NameCell)`
  display: flex;
  align-items: center;
  padding: 0;
`;

const SearchBox = styled(SearchInput)`
  margin: var(--spacing-05) 0;
`;

interface Props<List> {
  entityIdKey: string;
  actionBar: ReactNode;
  entities: List[];
  searchPlaceholder: string;
  filterFunction: (entity: List, searchText: string) => boolean;
  selectedEntities: List[];
  updateSelectedEntities: (entities: List[]) => void;
  isMultiSelect: boolean;
  columns: ColumnsType<AddToProjectRecordType<List>>;
}
export const ModalContent = <
  List extends User | Team | ReplacementUserForTeam,
>({
  entityIdKey,
  actionBar,
  entities,
  searchPlaceholder,
  filterFunction,
  selectedEntities,
  updateSelectedEntities,
  columns,
  isMultiSelect,
}: PropsWithChildren<Props<List>>): JSX.Element => {
  const [searchText, setSearchText] = useState('');

  const filteredEntities = useMemo(
    () => entities.filter((entity) => filterFunction(entity, searchText)),
    [entities, filterFunction, searchText],
  );

  return (
    <div>
      {actionBar}
      <SearchBox>
        <Input
          value={searchText}
          placeholder={searchPlaceholder}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Search16 />
      </SearchBox>
      <EntityListTable
        isMultiSelect={isMultiSelect}
        primaryKey={entityIdKey}
        columns={columns.concat({
          title: '',
          dataIndex: 'isSelected',
          key: 'isSelected',
          width: 48,
          render: (isSelected) => <RoundedCheckbox checked={isSelected} />,
        })}
        entities={filteredEntities}
        selectedEntities={selectedEntities}
        updateSelectedEntities={updateSelectedEntities}
      />
    </div>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin-top: calc(calc(var(--spacing-01) / 2) + var(--spacing-01));
`;

export const PartnerCompanyInfo = ({
  companyName,
}: {
  companyName: string;
}): JSX.Element => (
  <Wrapper>
    <Tooltip title={companyName}>
      <PartnershipIcon />
    </Tooltip>
  </Wrapper>
);
